import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {candidatAccepted, candidatStatusLabelsMap} from "../../../../../shared/utils/data/shared.data";
import {CandidatesApplied} from "../../../../../models/Mission";
import {MissionService} from "../../../../../services/mission.service";
import {FlagService} from "../../../../../shared/services/flag.service";
import {environment} from "../../../../../../environments/environment";
import {MatDialog} from "@angular/material/dialog";
import {CandidatStatusOnMission, FlagType, MissionStatusEnum} from "../../../../../shared/utils/enums";
import {CustomDialogComponent} from "../../../../../shared/custom-dialog/custom-dialog.component";
import {EtablissementData} from "../../../../../shared/utils/data/etablissments-data";
import {DetailsComponent} from "../../../../../pages/etablissement/candidatures/details/details.component";
import {SharedModule} from "../../../../../shared/shared.module";
import {SvgIconComponent} from "angular-svg-icon";
import { CandidatService } from '../../../../../services/candidat.service';
import { MessageDialogComponent } from '../../../../../shared/components/message-dialog';
import { ChatService } from '../../../../../services/chat.service';
import { CommonModule } from '@angular/common';
import { PermissionService } from '../../../../../services/permission.service';

@Component({
  selector: 'app-mission-candidatures',
  templateUrl: './mission-candidatures.component.html',
  standalone: true,
  imports: [
    SharedModule,
    SvgIconComponent,
    CommonModule
  ],
  styleUrl: './mission-candidatures.component.scss'
})
export class MissionCandidaturesComponent implements OnInit{
  @Input() candidatesApplied : CandidatesApplied[] = []
  @Input() availableCandidates : CandidatesApplied[] = []
  @Input() missionId : number
  @Input() etbId : number = 0;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter<any>()
  loading = false;
  @Input() expired = false;
  candidatesCanceledByAgency: CandidatesApplied[] = [];
  candidatesAccepted: CandidatesApplied[] =[]
  candidatesNotAccepted: CandidatesApplied[] =[]
  @Input() mData: any;
  isChatActive: boolean = true;
  private readonly permissionService = inject(PermissionService);
  constructor(private missionService: MissionService, private flag: FlagService, private dialog: MatDialog , private candidatService: CandidatService, private chatService: ChatService) {
  }

  /** « Répondre aux missions » (MISSION_VIEW) : accepter un candidat. Le back reste l'autorité (403). */
  get mayRespond(): boolean {
    return this.permissionService.has('MISSION_VIEW');
  }

  /** « Créer des missions » (MISSION_WRITE) : affecter directement une mission à un candidat. Le back reste l'autorité (403). */
  get mayAssign(): boolean {
    return this.permissionService.has('MISSION_WRITE');
  }

  ngAfterViewInit(): void {
    // Subscribe to chat active status
    this.chatService.chatActive$.subscribe((isActive: boolean) => {
      this.isChatActive = isActive;
    });
    this.isChatActive = this.chatService.isChatActive;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // Une candidature annulée par l'agence n'est plus « acceptée » : elle ne bloque pas l'acceptation d'un autre professionnel
    // et apparaît dans sa propre section (historique).
    this.candidatesAccepted = this.candidatesApplied.filter(c => candidatAccepted.includes(c.statusOfCandidatOnMission) && c.statusOfCandidatOnMission !== CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY)
    this.candidatesCanceledByAgency = this.candidatesApplied.filter(c => c.statusOfCandidatOnMission === CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY)
    this.candidatesNotAccepted = this.candidatesApplied.filter(c => !candidatAccepted.includes(c.statusOfCandidatOnMission))
    this.availableCandidates = [...this.availableCandidates]
  }


  acceptCancelRequest(candidate: CandidatesApplied){
    const dialog = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.mission.cancelRequest.title,
        description: EtablissementData.mission.cancelRequest.description,
        primaryLabel: EtablissementData.mission.cancelRequest.primaryButton,
        secondaryLabel: EtablissementData.mission.cancelRequest.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.missionService.acceptCancelRequest(candidate.candidatId, this.missionId).subscribe({
            next: () => {
                this.flag.displayFlag('Annulation de la candidature acceptée !', FlagType.success)
              this.closeSlider.emit(true)
            }
        })
      }
    })
  }

  updateApplicationStatus(candidate: CandidatesApplied, status = this.CandidatStatusOnMission.ACCEPTED) {
    const body = {
      candidatId: candidate.candidatId,
      missionId: this.missionId,
      status
    }
    this.loading = true;
    this.missionService.updateCandidateStatus(body).subscribe({
      next: (res) => {
        this.loading = false;
        candidate.statusOfCandidatOnMission = res.status;
        this.flag.displayFlag(`${candidate.candidateName} a été accepté pour cette mission`, FlagType.success)
        this.closeSlider.emit(true)
      },
      error: () => {
        this.loading = false;
        this.flag.displayFlag(`Veuillez contacter l'équipe Collary`, FlagType.error)
      },
    })
  }

  openDetailCandidate = (id: any) => {    
    this.dialog.open(DetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: {
        candidature: {candidatId: id, establishmentId: this.etbId}
      },
      // animation: { to: "left" }
    });
  };

  
    affectMissionToCandidate(candidateId: number, missionId: number) {
      const payload = {
        candidatId: candidateId,
        missionId: missionId,
        agencyId: Number(localStorage.getItem('id'))
      };

      console.log('Payload:', payload);
    
      this.candidatService.affectCandidatToMission(payload).subscribe({
        next: () => {
          // Display a success flag when the mission is successfully assigned
          this.flag.displayFlag('Mission affectée avec succès au candidat !', FlagType.success);

          // Clear the cache and refresh the current liberal missions
          this.missionService.clearCache(); // Clear the cache
          this.missionService.getLiberalCurrentMissions().subscribe({
            next: (missions) => {
              console.log('Current liberal missions refreshed:', missions);
              // Optionally, update a local variable if needed
              // this.currentMissions = missions;
            },
            error: (error) => {
              console.error('Failed to refresh current liberal missions:', error);
            },
          });

          this.closeSlider.emit(true); // Close the slider or perform any additional actions
        },
        error: (error) => {
          // Handle errors and display an error flag
          console.error('Error while affecting mission to candidate:', error);
          this.flag.displayFlag('Échec de l\'affectation de la mission. Veuillez réessayer.', FlagType.error);
        },
      });
    }

    openMessageDialog(item:any, event: MouseEvent) {
      console.log(item , this.mData);
            
      this.dialog.open(MessageDialogComponent, {
        width: '350px',
        position: {
          top: '32px',
          right: '32px'
        },
        panelClass: ['chat-popover-panel', 'arrow-none'],
        data: {
          candidatId: item.candidatId,
          missionId: this.mData?.id,
          missionTitle: this.mData?.missionTitle,
        }
      });
    }

  /** Statuts dont l'agence peut annuler la candidature (mission simple, non terminée, offre non annulée). */
  private static readonly CANCELLABLE = [
    CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION,
    CandidatStatusOnMission.ACCEPTED,
    CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION,
    CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH,
  ];

  /**
   * « Annuler la candidature » : en attente → droit « Répondre aux missions » (MISSION_VIEW) ;
   * acceptée / contrat à valider / signée → « Annuler une candidature (acceptée et/ou signée) » (MISSION_CANCEL). Le back reste l'autorité.
   */
  canCancelCandidacy(item: CandidatesApplied): boolean {
    if (this.expired || this.isMissionCanceled || this.mData?.isfragmentable) return false;
    if (!MissionCandidaturesComponent.CANCELLABLE.includes(item.statusOfCandidatOnMission)) return false;
    return this.permissionService.has(
      item.statusOfCandidatOnMission === CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION ? 'MISSION_VIEW' : 'MISSION_CANCEL');
  }

  cancelCandidacy(item: CandidatesApplied) {
    const dialogRef = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.mission.cancelCandidacy.title,
        description: EtablissementData.mission.cancelCandidacy.description,
        primaryLabel: EtablissementData.mission.cancelCandidacy.primaryButton,
        secondaryLabel: EtablissementData.mission.cancelCandidacy.secondButton,
        withFormInput: true,
        formInputPlaceholder: "Vous pouvez préciser la motif de l'annulation",
        formInputLabel: "Motif de l'annulation"
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (!res?.confirm) return;
      const motifBody = { motif: res.formValue && res.formValue != '' ? res.formValue : null };
      const status = item.statusOfCandidatOnMission;
      const call = status === CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION
        ? this.missionService.cancelCandidacyOnPendingMission(this.missionId, item.candidatId, motifBody)
        : status === CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
          ? this.missionService.cancelCandidacyOnAcceptedAndSignedMission(this.missionId, item.candidatId, motifBody)
          : this.missionService.cancelCandidacyOnAcceptedMission(this.missionId, item.candidatId, motifBody);
      this.loading = true;
      call.subscribe({
        next: () => {
          this.loading = false;
          item.statusOfCandidatOnMission = CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY;
          this.flag.displayFlag(`La candidature de ${item.candidateName} a été annulée`, FlagType.success);
          this.missionService.toggleRefreshMission();
          this.closeSlider.emit(true);
        },
        error: () => {
          this.loading = false;
          this.flag.displayFlag(`L'annulation de la candidature a échoué`, FlagType.error);
        },
      });
    });
  }

  // A canceled mission offer is read-only: no affect/accept action is allowed.
  get isMissionCanceled(): boolean {
    return this.mData?.missionStatus === MissionStatusEnum.CANCELED;
  }

  protected readonly CandidatStatusOnMission = CandidatStatusOnMission;
    protected readonly environment = environment;
    protected readonly candidatStatusLabelsMap = candidatStatusLabelsMap;

}
